export var getBannerByType = function (activitySearchStore, bannerType) {
  if (activitySearchStore.searchSummary && activitySearchStore.searchSummary.aboveTheFold && activitySearchStore.searchSummary.aboveTheFold.banners && activitySearchStore.searchSummary.aboveTheFold.banners.length > 0) {
    var banners = activitySearchStore.searchSummary.aboveTheFold.banners.filter(function (banner) {
      return banner.type === bannerType;
    });
    return banners;
  }
  return null;
};